<template>
  <section class="draw-menu tw-hidden md:tw-flex">
    <div class="menu-list" v-if="isMenuVisible">
      <div class="tw-text-4xl tw-font-black tw-text-white">INDEX</div>
      <NuxtLinkLocale class="menu-item" v-for="(menu, index) in props.menuList" :to="`/${root}#${menu.key}`" :key="index">
        {{ menu.name }}
      </NuxtLinkLocale>
    </div>
    <div class="menu-bar" @click="showMenu" v-if="isMenuVisible">
      <div class="img">
        <SvgoDevelopersCloseIndex />
      </div>
      <div class="bar-title tw-font-black">CLOSE</div>
    </div>
    <div class="menu-bar" @click="showMenu" v-else>
      <div class="img">
        <SvgoDevelopersOpenIndex />
      </div>
      <div class="bar-title tw-font-black">INDEX</div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const props = defineProps<{ root: string; menuList: Array<{ key: string; name: string }> }>()
  const isMenuVisible = ref(false)
  const showMenu = () => {
    isMenuVisible.value = !isMenuVisible.value
  }
</script>

<style scoped lang="scss">
  .draw-menu {
    position: fixed;
    border-top-right-radius: 2.5rem;
    border-bottom-right-radius: 2.5rem;
    background-color: colors(dark);
    align-items: center;
    z-index: 10;

    .menu-list {
      display: flex;
      flex-direction: column;
      height: 28.9375rem;
      width: 20.625rem;
      justify-content: center;
      border-right: solid 0.125rem colors(theme);
      padding-left: 2.5rem;

      .menu-item {
        @include fontSize(medium);

        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 2.6875rem;
        color: colors(light);
        text-decoration: underline;
      }

      .menu-item::before {
        content: '';
        width: 0.875rem;
        height: 0.875rem;
        background: url('/res/img/shadowbg/shape-interrupt.svg');
        background-size: cover;
        margin-right: 1rem;
      }
    }

    .menu-bar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 4.375rem;
      height: 28.9375rem;

      .bar-title {
        @include fontSize(base);

        transform: rotate(-90deg);
        color: colors(light);
        width: 4.25rem;
        justify-content: center;
      }

      .img {
        width: 0.9375rem;
        height: auto;
        margin-bottom: 2.25rem;
      }
    }
  }
</style>
